module.exports = __webpack_public_path__ + "images/assets/ee539bfdc33428567728936bc6a86767.svg";